module.exports = __webpack_public_path__ + "img/symbol_9.ca32ac39.png";